import { FC, useEffect, useRef, useState } from "react"
import { formatInt, timeSince } from "utils"
import { Tag } from "../base/tag"

export type NewItemProps = {
  img?: string
  title?: string
  tag?: string
  views?: number
  postedDate?: string
  content?: string
  hiddenContent?: boolean
}

export const NewItem: FC<NewItemProps> = (props) => {
  const { img, title, tag, views, postedDate, content, hiddenContent } = props;
  const [lineClampNumber, setLineClampNumber] = useState(0)
  const [imageLoaded, setImageLoaded] = useState<boolean>(false)
  const imageRef = useRef<HTMLImageElement | null>(null)
  const i4Ref = useRef<HTMLDivElement | null>(null)
  const contentRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!imageLoaded || !imageRef.current || !i4Ref.current || !contentRef.current) return;

    const imgSize = window.getComputedStyle(imageRef.current).height

    i4Ref.current.style.height = imgSize

    const contentStyle = window.getComputedStyle(contentRef.current)

    const contentHeight = parseInt(contentStyle.height.replace('px', ''))
    const contentLineHeight = parseInt(contentStyle.lineHeight.replace('px', ''))
    const clamp = parseInt(contentHeight / contentLineHeight + '')
    console.log({ clamp, contentLineHeight, contentHeight });
    contentRef.current.style.height = clamp * contentLineHeight + 'px';
    setTimeout(() => contentRef.current?.classList.remove('flex-1'), 0)


    setLineClampNumber(clamp)
  }, [imageLoaded])

  return <div className="flex gap-2 dark:text-white">
    <div className="flex-1">
      <img src={img} alt="" onLoad={() => setImageLoaded(true)} ref={imageRef} className="block aspect-w-16 aspect-h-9 p-0" />
    </div>
    <div className="flex flex-1 flex-col" ref={i4Ref}>
      <Tag>{tag}</Tag>
      <div className="line-clamp-2">{title}</div>
      <div className="text-xs text-gray-400">{timeSince(postedDate)} - {formatInt(views)} lượt xem</div>
      <div className={`text-sm dark:text-gray-200 flex-1 overflow-hidden line-clamp-${lineClampNumber}${hiddenContent ? " hidden" : ''}`} ref={contentRef}>{content}</div>
    </div>
  </div >
}
